
<template>
    
    <div class="hr_block">
        <div class="row" :class="{'flex-wrap-reverse' : is_modal}">
        <div :class="col_left">
            <div class="hr_edit_inside">
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        ПІБ *
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal fa-typewriter fs-xl" ></i>
                    </span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="user_data.name">
                    </div>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        Дата народження
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal  fa-typewriter fs-xl" ></i>
                    </span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="user_data.birthday">
                    </div>
                </div>
                
                
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        Користувач транслiт *
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal  fa-typewriter fs-xl" ></i>
                    </span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="user_data.username">
                    </div>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        Пароль
                        <span class="small" v-if="is_modal">Залиште пустим, якщо без змін</span>
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal  fa-typewriter fs-xl" ></i>
                    </span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="user_data.password">
                    </div>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        Вiддiл*
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal  fa-typewriter fs-xl" ></i>
                    </span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="user_data.department">
                    </div>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        Посада*
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal  fa-typewriter fs-xl" ></i>
                    </span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="user_data.dolznost">
                    </div>
                </div>
                
                <div class="template" >
                    <users_org_select
                        @on_item_set="set_company"
                        :active_name="user_data.company">
                    </users_org_select>
                </div>
                
                <div class="template" >
                    <cluster_select
                        @on_item_set="set_cluster_id"
                        :active_id="parseInt(user_data.serv_id)">
                    </cluster_select>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        Тел. робочий
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal  fa-typewriter fs-xl" ></i>
                    </span>
                        </div>
                        <input id="advanced_name"
                               maxlength="10"
                               inputmode="numeric"
                               @input="user_data.mobile = user_data.mobile.replace(/\D/g, '').slice(0, 10)"
                               pattern="[0-9]*" type="text" class="form-control" v-model="user_data.mobile">
                    </div>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        Тел. особистий
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal  fa-typewriter fs-xl" ></i>
                    </span>
                        </div>
                        <input id="advanced_name"     maxlength="10"
                               inputmode="numeric"
                               @input="user_data.home = user_data.home.replace(/\D/g, '').slice(0, 10)"
                               pattern="[0-9]*" type="text" class="form-control" v-model="user_data.home">
                    </div>
                </div>
            
            </div>
        </div>
        <div :class="col_right">
            <div v-if="doc.user_id > 0">
                <h2>Користувач</h2>
                <user-block :user_id="doc.user_id"></user-block>
            </div>
        </div>
    </div>
        
        <div class="buttons pt-3">
            <div class="next_step">
                <button class="btn btn-lg btn-outline-success save_user waves-effect waves-themed" :disabled="!can_save" v-on:click="save_info" v-if="doc.confirmed == 0">
                    Зберегти
                    <div class="ripple-wrapper"></div>
                </button>
                
                <button class="btn btn-lg btn-outline-success save_user waves-effect waves-themed ml-5" v-if="can_confirm"  v-on:click="confirm" >
                    Затвердити
                    <div class="ripple-wrapper"></div>
                </button>
                
                <button class="btn btn-lg btn-outline-primary save_user waves-effect waves-themed"
                        :class="{'ml-5' : doc.confirmed == 0}"
                        v-on:click="go_main" >Закрити
                    <div class="ripple-wrapper"></div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import organization_select from "../../../shared/select/organization_select.vue";
import vSelect from 'vue-select';
import UserBlock from "../../../shared/user/user_block/user_block.vue";
import Cluster_select from "../../../shared/select/cluster_select.vue";
import users_org_select from "../../../shared/select/users_org_select.vue";

export default {
    name: "hr_add",
    
    components : {
        Cluster_select,
        UserBlock,
        vSelect,
        organization_select,
        users_org_select
    },
    
    props : {
        doc_id : {
            type : Number | String,
            default : 0
        },
        is_modal : {
            type : Boolean,
            default : false,
        },
    },
    
    data() {
        return {
            doc : {
                "id" : 0,
                confirmed : 0,
                "user_id" : 0,
                "cur_rights" : "",
                "user_data" : {
                    "company" : ""
                },
            },
        }
    },
    
    created() {
        this.load_info()
    },
    
    methods : {
        go_main() {
            if(!this.is_modal) {
                window.location.href = '/hr/stvoryty-dokument/hr_action/';
            }
            else {
                this.$emit('close_modal');
            }
        },
        
        close_reload() {
            this.$emit('close_reload_modal');
        },
        
        set_company(company) {
            this.doc.user_data.company = company;
        },
        
        set_cluster_id(item_id) {
            this.doc.user_data.serv_id = item_id;
        },
        
        async load_info () {
            this.doc = this.default_doc;
            await api.get('/hr/docs/' + this.doc_id).then(({data}) => {
                if (data.status === "operation_success") {
                    this.doc = data.data;
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        
        async confirm() {
            await api.patch('/hr/docs/' + this.doc_id,this.doc).then(({data}) => {
                if (data.status === "operation_success") {
                    IMC_CORE.snackbar('OK');
                    this.close_reload();
                }
                
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {
                    position : "b-toaster-top-left",
                    err: "CODE:" + response.status + " " + response.data.message, type: "danger", title: response.data.status})
            });
        },
        
        async save_info() {
            await api.put('/hr/docs/' + this.doc_id,this.doc).then(({data}) => {
                if (data.status === "operation_success") {
                    IMC_CORE.snackbar('OK');
                    if(this.is_modal) {
                        this.close_reload();
                    }
                    else {
                        this.go_main();
                    }
                    
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {
                    position : "b-toaster-top-left",
                    err: "CODE:" + response.status + " " + response.data.message, type: "danger", title: response.data.status})
            });
        }
    },
    
    computed : {
        
        col_right () {
            if(this.is_modal) {
                return  'col-12 mt-4';
            }
            
            return 'col-xl-4 col-md-4 col-lg-4 col-xs-12';
        },
        
        
        col_left () {
            if(this.is_modal) {
                return  'col-12 mt-4';
            }
            
            return 'col-xl-8 col-md-8 col-lg-8 col-xs-12';
        },
        
        default_doc() {
            return  {
                "id" : 0,
                "user_id" : 0,
                "user_data" : {
                    "company" : "",
                },
            };
        },
        
        user_data () {
            return this.doc.user_data;
        },
        
        can_confirm() {
            return this.doc.cur_rights == 'admin' && parseInt(this.doc.id) > 0 && parseInt(this.doc.confirmed) == 0;
        },
        
        can_save() {
            let can_save = true;
            
            let fields_check = [
                'name',
                'username',
               // "password",
                'serv_id',
                "company",
                'department',
                'dolznost',
            ];
            
            fields_check.map(type => {
                if(!this.doc.user_data.hasOwnProperty(type)) {
                    can_save = false;
                }
                else {
                    if(this.doc.user_data[type].length <= 0) {
                        can_save = false;
                    }
                }
            })
            
            return can_save;
        },
    }
}
</script>


<style scoped>

</style>